export default {"src":"https://dev-static.skin-seoul.com/_next/static/media/next-page-button.98dfdde9.svg","height":24,"width":55,"blurWidth":0,"blurHeight":0};